import type { IconSvgObject } from './types';

const TaskAdd01Icon: IconSvgObject = [
  ["path", { d: "M19 12.9981L19 5.5C19 4.39543 18.1046 3.5 17 3.5H15M14 21.9981L5 21.9981C3.89543 21.9981 3 21.1027 3 19.9981V5.5C3 4.39543 3.89543 3.5 5 3.5L7 3.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M13.5 2H8.5C7.67157 2 7 2.67157 7 3.5C7 4.32843 7.67157 5 8.5 5H13.5C14.3284 5 15 4.32843 15 3.5C15 2.67157 14.3284 2 13.5 2Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M7 15H10.4286M7 11H15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M21 19H18M18 19H15M18 19V22M18 19V16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default TaskAdd01Icon;
